module.exports = __webpack_public_path__ + "static/media/fruits-cut600.839de95b.jpeg";